// @flow
import React, { Component } from 'react';
import { DefaultIcon } from '../../components/Icon';
import {
  FailedMerchantRegistrationsErrorMessage,
  CustomBlueTextLink
} from './MerchantsStyles';

type Props = {};

export default class FailedMerchantRegistrationsMessage extends Component<Props> {
  render() {
    return (
      <FailedMerchantRegistrationsErrorMessage>
        <DefaultIcon name="warning" colorName="red" />
        <div>
          <p>Some direct merchants failed to upload.</p>
          <CustomBlueTextLink to="/merchants/registrations/csv">
            Please review the errors here.
          </CustomBlueTextLink>
        </div>
      </FailedMerchantRegistrationsErrorMessage>
    );
  }
}
